/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Start_Review_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Start Review" |
*
* @param {Style_Guide_Start_Review_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_start_review_aria_label = /** @type {((inputs?: Style_Guide_Start_Review_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Start_Review_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Demarrer l'examen")
	if (locale === "de") return /** @type {LocalizedString} */ ("Bewertung starten")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inizia la revisione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Начать обзор")
	if (locale === "es") return /** @type {LocalizedString} */ ("Iniciar revisión")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("开始评论")
	if (locale === "ja") return /** @type {LocalizedString} */ ("レビューを開始")
	if (locale === "hi") return /** @type {LocalizedString} */ ("समीक्षा शुरू करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Iniciar avaliação")
	return /** @type {LocalizedString} */ ("Start Review")
});